import React, {useState} from "react";
import _ from "lodash";
import { useEffect } from "react";
import api from "api";
import update from "immutability-helper";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import { AvatarVertical1 } from "component/Avatar";
import "./index.scss";
import { Link } from "react-router-dom";
import { StarsList } from "component/Rating";

const TalentPoolSlider = connect(stateMap)((props) => {
    const [isEOF, setIsEOF]             = useState(false);
    const [isLoading, setIsLoading]     = useState(true);
    const [Talents, SetTalents] = useState(props.talents || false);

    const [listArgs, setListArgs]       = useState(_.assignIn({}, {
        posts_per_page : 5
        ,paged : 1
        ,include_user_score : 1
    }, props.list_args) || {});

    useEffect(() => {
        if( !_.isUndefined(props.talents) )
        {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        api('/TalentPool', 'post', listArgs, 'Bearer ' + props.auth.token).then(response => {
            setIsLoading(false);

            if(response.talent.length < listArgs.posts_per_page)
            {
                setIsEOF(true);
            }

            if(Talents !== false)
            {
                SetTalents( Talents.concat(response.talent));
            }
            else
            {
                SetTalents(response.talent);
            }
            
        })
        .catch(() => {
            setIsLoading(false);
            setIsEOF(true);
        })

    }, [listArgs]);

    return(
        <div className="component-talent-pool">
            <ul className="the-talents">
                {
                    Talents !== false && Talents.map((User) => (
                        <li className="the-talent" key={User.UserID}>
                            <span className="talent-card text-center">
                                <AvatarVertical1 user={User}>
                                    <div className="user-short-bio" dangerouslySetInnerHTML={{__html : User.UserShortBio}}></div>
                                    <div className="user-rating">
                                        <div className="user-score">
                                            {User.UserScore}
                                        </div>
                                        <div className="user-stars">
                                            <StarsList score={User.UserScore} />
                                        </div>
                                    </div>
                                </AvatarVertical1>
                            </span>
                        </li>
                    ))
                }
                {
                    isLoading && 
                    <li className="the-talent">
                        <div className="talent-card">
                            <div className="card-skeleton talent-card-wrapper relative">
                                <span className="skeleton"></span>
                            </div>
                        </div>
                    </li>
                }
                {
                    Talents !== false && Talents.length == 0 &&
                    <li className="the-talent">
                        <div className="talent-card">
                            <div className="card-not-found talent-card-wrapper relative">
                                <span className="text-center bold block mt-4">
                                    No User Found
                                </span>
                            </div>
                        </div>
                    </li>
                }
            </ul>
        </div>
    )
})

export {TalentPoolSlider}